import React from "react";
// import { graphql } from "gatsby";
import Link from "gatsby-plugin-transition-link";
import { StaticImage } from "gatsby-plugin-image";

import ModalContact from "../Modal/ModalContact";
import ModalApply from "../Modal/ModalApply";
import nest from "../../images/Global/Footer/Nest Logo.svg";

import { useStaticQuery, graphql } from "gatsby";

const Footer = ({ hideFooter, contactInfo, siteSettings }) => {
  const data = useStaticQuery(graphql`
    query {
      siteSettings: sanitySiteSettings {
        title
        description
        author
        headerlogo {
          asset {
            gatsbyImageData
          }
        }
        footerlogo {
          asset {
            gatsbyImageData
          }
        }
        facebookurl
        twitterurl
        privacypolicy
      }
      contactInfo: sanityContactinfo {
        title
        description
        phonenumber
        email
        address
        license
        bookingurl
      }
    }
  `);

  // const { data, errors } = props;
  const getYear = () => {
    return new Date().getFullYear();
  };

  const serviceMenuItems = [
    {
      name: "Assisted Living",
      path: "/assisted-living-encinitas/",
    },
    {
      name: "Alzheimer’s Care",
      path: "/memory-care-encinitas/",
    },
    {
      name: "Dementia Care",
      path: "/dementia-care-san-diego/",
    },
    {
      name: "Respite Care",
      path: "/respite-care-san-diego/",
    },
    {
      name: "Hospice Care",
      path: "/hospice-facility-san-diego/",
    },
    {
      name: "Enriching Experiences",
      path: "/enriching-experiences/",
    },
  ];

  const companyMenuItems = [
    {
      name: "About Us",
      path: "/about/",
    },
    {
      name: "Reviews",
      path: "/reviews/",
    },
    {
      name: "Amenities",
      path: "/amenities/",
    },
    {
      name: "Neighborhood",
      path: "/neighborhood/",
    },

    {
      name: "Blog",
      path: "/caregiver-blog/",
    },
  ];

  return (
    <>
      <footer
        className={`bg-primary-900 px-8 pb-10 pt-14 md:px-0 md:pb-3 md:pt-20 ${
          hideFooter && "hidden"
        }`}
      >
        <div className="container">
          <div className="mb-10 grid gap-y-16 md:grid-cols-12 md:gap-x-10 lg:gap-x-20">
            <div className="text-center md:col-span-4 md:col-start-1 md:text-left">
              <Link to="/">
                <StaticImage
                  src="../../images/Global/Logo/logo-white.png"
                  alt="RanchView Logo"
                  loading="lazy"
                  width={317}
                  className="w-[199px] md:w-[317px]"
                />
              </Link>
            </div>
            <div className="md:col-span-8 md:col-end-13">
              <div className="flex flex-col text-white md:flex-row">
                <div className="flex md:hidden">
                  {serviceMenuItems && (
                    <div className="w-full pb-5">
                      <div className="mb-6 font-semibold">Services</div>
                      <ul className="space-y-1.5">
                        {serviceMenuItems.map((item, index) => (
                          <li key={`serviceItem${index}`}>
                            <Link
                              className="text-sm font-normal text-white/70 no-underline hover:text-white"
                              to={item.path}
                            >
                              {item.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {companyMenuItems && (
                    <div className="w-full pb-5">
                      <div className="mb-6 font-semibold">Company</div>
                      <ul className="space-y-1.5">
                        {companyMenuItems.map((item, index) => (
                          <li key={`companyItem${index}`}>
                            <Link
                              className="text-sm font-normal text-white/70 no-underline hover:text-white"
                              to={item.path}
                            >
                              {item.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>

                {serviceMenuItems && (
                  <div className="hidden w-full pb-5 md:block">
                    <div className="mb-6 font-semibold">Services</div>
                    <ul className="space-y-1.5">
                      {serviceMenuItems.map((item, index) => (
                        <li key={`serviceItem${index}`}>
                          <Link
                            className="text-sm font-normal text-white/70 no-underline hover:text-white"
                            to={item.path}
                          >
                            {item.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {companyMenuItems && (
                  <div className="hidden w-full pb-5 md:block">
                    <div className="mb-6 font-semibold">Company</div>
                    <ul className="space-y-1.5">
                      {companyMenuItems.map((item, index) => (
                        <li key={`companyItem${index}`}>
                          <Link
                            className="text-sm font-normal text-white/70 no-underline hover:text-white"
                            to={item.path}
                          >
                            {item.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                <div className="w-1/2 pb-5 md:w-full">
                  <div className="mb-6 font-semibold">Contact</div>
                  <ul className="space-y-3 text-left">
                    <li key={`companyItem0`}>
                      <a
                        className="text-sm font-normal text-white/70 no-underline hover:text-white"
                        href="https://goo.gl/maps/affPVuk7mUMrxdBs6"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {data.contactInfo.address}
                      </a>
                    </li>
                    <li key={`companyItem1`}>
                      <a
                        className="text-sm font-normal text-white/70 no-underline hover:text-white"
                        href={`tel:${data.contactInfo.phonenumber
                          .replace(/[()]/g, "")
                          .replace(/ /g, "-")}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {data.contactInfo.phonenumber}
                      </a>
                    </li>
                    <li key={`companyItem2`}>
                      <Link
                        className="text-sm font-normal text-white/70 no-underline hover:text-white"
                        to={`mailto:${data.contactInfo.email}`}
                      >
                        {data.contactInfo.email}
                      </Link>
                    </li>
                    <li
                      key={`companyItem3`}
                      className="text-sm font-normal text-white/70 no-underline"
                    >
                      {data.contactInfo.license}
                    </li>
                  </ul>
                </div>

                <div className="items-right block flex justify-start space-x-5 md:hidden">
                  <a
                    href={data.siteSettings.facebookUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white no-underline hover:text-primary-500"
                  >
                    <i className="fab fa-facebook-f text-xl"></i>
                  </a>
                  <a
                    href={data.siteSettings.twitterUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white no-underline hover:text-primary-500"
                  >
                    <i className="fab fa-twitter text-xl"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="-mx-12 mb-5 border-t border-white/30"></div>

          <div className="grid items-center justify-center md:flex md:justify-between">
            <ul className="flex flex-wrap items-center md:space-x-4">
              <div className="flex w-full flex-col flex-wrap items-center justify-center space-y-3 md:w-auto md:flex-row md:space-x-4 md:space-y-0">
                <li className="text-sm text-white/70">
                  © {getYear()} RanchView Senior Assisted Living
                </li>
                <li>
                  <Link
                    to="/privacy-policy/"
                    className="text-sm font-normal text-white/70 no-underline hover:text-white"
                  >
                    Privacy Policy
                  </Link>
                </li>
                <li className="text-sm">
                  <a
                    className="group flex items-center justify-center space-x-1 text-sm font-normal text-white/70 no-underline hover:text-white md:justify-start"
                    href="https://www.wisedigitalpartners.com/nest-by-wise/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Powered by{" "}
                    <img src={nest} alt="NEST logo" className="ml-1" />
                  </a>
                </li>
              </div>
            </ul>

            <div className="hidden py-5 md:block">
              <div className="items-right flex justify-center space-x-5">
                {/* <div className="mb-16 flex items-right justify-center space-x-10 md:mb-7"> */}
                <a
                  href={data.siteSettings.facebookUrl}
                  // href=""
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white no-underline hover:text-primary-500"
                >
                  <i className="fab fa-facebook-f text-xl"></i>
                </a>
                <a
                  href={data.siteSettings.twitterUrl}
                  // href=""
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white no-underline hover:text-primary-500"
                >
                  <i className="fab fa-twitter text-xl"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <ModalContact contactInfo={contactInfo} />
      <ModalApply />
    </>
  );
};

export default Footer;
